<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card-box m-0">
                <form role="form" @submit.prevent="doFilter()">
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-8 m-b-15">
                            <label>{{ $t('general_search') }}</label>
                            <input type="text" v-model="filter.search" class="form-control" :placeholder="$t('_incoming.filter_main_field_placeholder')">
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-4 m-b-15">
                            <label>{{ $t('status') }}</label>
                            <pml-multiselect v-model="filter.status_s" :options="status"></pml-multiselect>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-4 m-b-15">
                            <label>{{ $t('entry_date') }}</label>
                            <div class="input-daterange input-group">
                                <pml-date-picker v-model="filter.created_at_from"></pml-date-picker>
                                <span class="input-group-addon b-0"><i class="fa fa-calendar"></i></span>
                                <pml-date-picker v-model="filter.created_at_to"></pml-date-picker>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 m-b-15">
                            <label>{{ $t('consultant') }}</label>
                            <pml-select-members v-model="filter.member_id" :only-me="!member.is_admin" :onlyActive="true"></pml-select-members>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 m-b-15">
                            <label>{{ $t('follower') }}</label>
                            <pml-select-members v-model="filter.follower_id" :allow-empty="true" :all="true" :only-follow="true" :onlyActive="true"></pml-select-members>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 m-b-15">
                            <label>{{ $t('source') }}</label>
                            <pml-select v-model="filter.source_id" :options="sources"></pml-select>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 m-b-15">
                            <label>{{ $t('segment') }}</label>
                            <pml-select v-model="filter.segment_id" :options="segments"></pml-select>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 m-b-15">
                            <label>{{ $t('pipeline') }}</label>
                            <pml-select-group class="select_pipeline" v-model="filter.pipeline_step_id" :options="pipelines" group-values="steps" group-label="name"></pml-select-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 m-b-15">
                            <span class="m-r-15">{{ $t('show_deals') }}:</span>
                            <label class="label_radio m-r-20">
                                <input type="radio" name="has_lead" v-model="filter.has_lead" value="all" />
                                <span class="pull-left m-r-5"></span> {{ $t('all_a') }} <label class="label label-light bold f_size_12">{{ withLeads+noLeads }}</label>
                            </label>
                            <label class="label_radio m-r-20">
                                <input type="radio" name="has_lead" v-model="filter.has_lead" value="true" />
                                <span class="pull-left m-r-5"></span> {{ $t('with_lead') }} <label class="label label-light bold f_size_12">{{ withLeads }}</label>
                            </label>
                            <label class="label_radio m-r-20">
                                <input type="radio" name="has_lead" v-model="filter.has_lead" value="false" />
                                <span class="pull-left m-r-5"></span> {{ $t('no_lead') }} <label class="label label-light bold f_size_12">{{ noLeads }}</label>
                            </label>
                        </div>
                    </div>
                    <div class="row" v-if="duplicates > 0">
                        <div class="col-xs-12 m-b-15">
                            <span class="m-r-15">{{ $t('duplicate_deals') }}:</span>
                            <label class="label_radio m-r-20">
                                <input type="radio" name="has_duplicated" v-model="filter.has_duplicated" value="false" />
                                <span class="pull-left m-r-5"></span> {{ $t('all_a') }}
                            </label>
                            <label class="label_radio m-r-20">
                                <input type="radio" name="has_duplicated" v-model="filter.has_duplicated" value="true" />
                                <span class="pull-left m-r-5"></span> {{ $t('only_duplicate') }}
                            </label>
                        </div>
                    </div>
                    <div class="clearfix">
                        <span class="btn btn-white pull-left" @click.prevent="clear()"><i class="fa fa-paint-brush"></i> {{ $t('clear') }}</span>
                        <button class="btn btn_green pull-right" type="submit">
                            <span class="btn-label">
                                <i class="fa fa-search"></i>
                            </span>
                            {{ $t('filter') }}
                        </button>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-xs-12 col-sm-8 m_sm_bottom_15 t_sm_center">
                            <div class="btn-group pull-left btn_mobile_block">
                                <button type="button" class="btn btn-primary btn-sm m-t-5 dropdown-toggle btn_mobile_block" data-toggle="dropdown" aria-expanded="false">{{ $t('sort_by') }}: {{ orderedBy }} <span class="caret"></span></button>
                                <ul class="dropdown-menu" role="menu">
                                    <li><a href="javascript:;" @click.prevent="setOrderBy('first_name', 'asc')">{{ $t('name') }}</a></li>
                                    <li><a href="javascript:;" @click.prevent="setOrderBy('created_at', 'desc')">{{ $t('entry_date') }}</a></li>
                                    <li><a href="javascript:;" @click.prevent="setOrderBy('member_id', 'asc')">{{ $t('consultant') }}</a></li>
                                    <li><a href="javascript:;" @click.prevent="setOrderBy('source_id', 'asc')">{{ $t('source') }}</a></li>
                                    <li><a href="javascript:;" @click.prevent="setOrderBy('segment_id', 'asc')">{{ $t('segment') }}</a></li>
                                    <li><a href="javascript:;" @click.prevent="setOrderBy('email', 'asc')">{{ $t('email') }}</a></li>
                                </ul>
                            </div>
                            <span class="m-t-10 m-l-10 d_inline_b">{{ $t('data_grid_entries_showing_paginate', { from: pagination.from, to: pagination.to, total: pagination.total }) }}</span>
                        </div>
                        <div class="col-xs-12 col-sm-4 t_right">
                            <router-link :to="{ name: 'incoming.import' }" class="btn btn-inverse btn_mobile_block">
                                <span class="btn-label">
                                    <i class="wi wi-cloud-up"></i>
                                </span>
                                {{ $t('import') }}
                            </router-link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-sm-5">
            <div class="btn-group btn_mobile_block">
                <button type="button" class="btn btn-white btn-sm m-t-5 dropdown-toggle btn_mobile_block m-b-5" data-toggle="dropdown" aria-expanded="false">{{ $t('data_grid_entries_showing', [filter.perPage]) }} <span class="caret"></span></button>
                <ul class="dropdown-menu" role="menu">
                    <li><a href="javascript:;" @click.prevent="setPerPage(30)">30</a></li>
                    <li><a href="javascript:;" @click.prevent="setPerPage(60)">60</a></li>
                    <li><a href="javascript:;" @click.prevent="setPerPage(90)">90</a></li>
                    <li><a href="javascript:;" @click.prevent="setPerPage(120)">120</a></li>
                </ul>
            </div>
        </div>
        <div class="col-sm-7 t_right">
            <button class="btn btn-sm m-t-5 btn_mobile_block btn-default" v-pml-block="acceptingAll" @click.prevent="acceptAll()">
                <span class="btn-label">
                    <i class="fa fa-check"></i>
                </span>
                {{ $t('approve_x_deals', [pendingDeals]) }}
            </button>
            <button class="btn btn-sm m-t-5 btn_mobile_block btn-danger" v-pml-block="refusingAll" @click.prevent="refuseAll()">
                <span class="btn-label">
                    <i class="fa fa-ban"></i>
                </span>
                {{ $t('refuse_x_deals', [pendingDeals]) }}
            </button>
        </div>
        <div class="col-xs-12" v-if="duplicates > 0 && filter.has_duplicated !== 'true'">
            <a class="m-t-10 m-b-0 show alert alert-danger text-center alert_danger_hover" href="javascript:;" @click.prevent="searchForDuplicate">
                <h4 class="m-t-0 m-b-5"><i class="fa fa-exclamation-triangle"></i> <strong>{{ $t('attention') }}!</strong></h4>
                <span v-html="$t('there_are_duplicated_deals', [duplicates])"></span>
            </a>
                <!-- Existem <strong>{{ duplicates }}</strong> negociações duplicadas, clique aqui para visualizá-las</a> -->
        </div>
    </div>
</template>

<script>
    import bus from 'utils/events/bus'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { mapGetters } from 'vuex'
    import { refuseAll, acceptAll, getAllPaged } from 'services/incoming'
    import { irreversible } from 'utils/helpers/sweet-alert'
    import { map } from 'lodash'

    export default {
        name: 'IncomingFilter',
        data () {
            return {
                pendingDeals: 0,
                withLeads: 0,
                noLeads: 0,
                duplicates: false,
                page: 1,
                acceptingAll: false,
                refusingAll: false,
                pagination: {
                    data: [],
                    from: 0,
                    to: 0,
                    total: 0
                },
                showAdvancedFilter: false,
                loadingFilters: false,
                filter: {
                    perPage: 30,
                    created_at_from: '',
                    created_at_to: '',
                    orderBy: 'created_at',
                    orderDirection: 'desc',
                    member_id: '',
                    follower_id: '',
                    source_id: '',
                    segment_id: '',
                    pipeline_step_id: '',
                    status_s: ['pending'],
                    has_lead: 'all',
                    has_duplicated: 'false'
                }
            }
        },
        computed: {
            ...mapGetters({
                'perceptions': 'getDealPerceptions',
                'segments': 'getSegments',
                'sources': 'getSources',
                'members': 'getMembers',
                'member': 'getMember',
                'status': 'getIncomingStatus',
                'teams': 'getTeams',
                'pipelines': 'getPipelines'
            }),
            orderedBy () {
                if (this.filter.orderBy === 'first_name') return trans('name')
                if (this.filter.orderBy === 'created_at') return trans('entry_date')
                if (this.filter.orderBy === 'member_id') return trans('consultant')
                if (this.filter.orderBy === 'source_id') return trans('source')
                if (this.filter.orderBy === 'segment_id') return trans('segment')
                if (this.filter.orderBy === 'email') return trans('email')
            },
            loadedRecords () {
                return map(this.pagination.data, (item) => item.id)
            }
        },
        created () {
            bus.$on('doFilterIncoming', this.doFilter)
            bus.$on('emailCompareIncoming', this.emailCompare)
            bus.$on('decreaseDeals', () => { this.pendingDeals-- })
        },
        destroyed () {
            bus.$off('doFilterIncoming')
            bus.$off('emailCompareIncoming')
            bus.$off('decreaseDeals')
        },
        mounted () {
            this.doFilter(1)
        },
        methods: {
            setPerPage (amount) {
                this.filter.perPage = amount
                this.doFilter(1)
            },
            setOrderBy (orderBy, direction) {
                this.filter.orderBy = orderBy
                this.filter.orderDirection = direction
                this.doFilter(1)
            },
            clear () {
                this.filter = {
                    created_at_from: '',
                    created_at_to: '',
                    member_id: '',
                    follower_id: '',
                    source_id: '',
                    segment_id: '',
                    pipeline_step_id: '',
                    status_s: ['pending'],
                    has_lead: 'all',
                    duplicates: 0
                }
                this.doFilter(1)
            },
            doFilter (page = null) {
                bus.$emit('listLoadingIncoming', true)

                this.page = page === null ? this.page : page

                getAllPaged(this.page, this.filter)
                    .then(response => {
                        this.pagination = response.data.records
                        bus.$emit('paginationRefreshIncoming', response.data.records)
                        this.pendingDeals = this.pagination.data.length
                        this.withLeads = response.data.countWithLeads
                        this.noLeads = response.data.countNoLeads
                        this.duplicates = response.data.duplicates
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => bus.$emit('listLoadingIncoming', false))
            },
            acceptAll () {
                irreversible()
                    .then((response) => {
                        if (response.value) {
                            this.acceptingAll = true
                            acceptAll(this.loadedRecords)
                                .then(() => this.doFilter())
                                .catch(() => Notify.error(trans('_notifications.error')))
                                .then(() => { this.acceptingAll = false })
                        }
                    })
            },
            refuseAll () {
                irreversible()
                    .then((response) => {
                        if (response.value) {
                            this.refusingAll = true
                            refuseAll(this.loadedRecords)
                                .then(() => this.doFilter())
                                .catch(() => Notify.error(trans('_notifications.error')))
                                .then(() => { this.refusingAll = false })
                        }
                    })
            },
            emailCompare (email) {
                this.filter.search = email
                this.filter.status_s = [ 'pending' ]
                this.doFilter(1)
            },
            searchForDuplicate () {
                this.filter.has_duplicated = 'true'
                this.doFilter(1)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/incoming/components/list/Filter.vue